import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { userActions } from '../../actions';
import './ExportService.css';
import { useParams, useHistory } from 'react-router-dom';

const ExportService = () => {
  const { _userId, _designId, _token } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(userActions.setToken({ userId: _userId, authToken: _token }));
    const redirectTimer = setTimeout(() => {
      history.push(`/export/design/${_designId}`);
    }, 500);

    return () => clearTimeout(redirectTimer);
  }, [_designId, _token, _userId, dispatch, history]);

  return (
    <div className="loaderContainer">
      <div className="lds-grid">
        <div></div><div></div><div></div><div></div><div></div>
        <div></div><div></div><div></div><div></div>
      </div>
    </div>
  );
};

export default ExportService;
